import { Party } from './party';
import { Site } from './site';

export enum DocumentStatusEnum {
  DRAFT = 'draft',
  CONFIRMED = 'confirmed',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  CONVERTED = 'converted',
}

export interface DocumentItemCreate {
  item_id: number;
  quantity: number;
  rate: number;
  discount_percent?: number;
  discount_amount?: number;
  tax_rate_id?: number | null;
  godown_id?: number | null;
  description?: string;
  amount?: number;
  tax_amount?: number;
  total_amount?: number;
}

export interface DocumentItemResponse extends DocumentItemCreate {
  id: number;
  item_name?: string;
  item_code?: string;
  tax_name?: string;
  tax_percent?: number;
  created_at: string;
  updated_at: string;
}

export interface QuotationCreate {
  party_id: number;
  site_id?: number | null;
  transaction_date: string | Date;
  valid_until_date?: string | Date | null;
  reference_number?: string | null;
  terms_and_conditions?: string | null;
  notes?: string | null;
  items: DocumentItemCreate[];
  status?: DocumentStatusEnum;
  total_amount?: number;
}

export interface QuotationUpdate {
  party_id?: number;
  site_id?: number | null;
  transaction_date?: string | Date;
  valid_until_date?: string | Date | null;
  reference_number?: string | null;
  terms_and_conditions?: string | null;
  notes?: string | null;
  items?: DocumentItemCreate[];
  status?: DocumentStatusEnum;
}

export interface QuotationResponse {
  id: number;
  document_number: string;
  document_type: string;
  party_id: number;
  party?: Party;
  site_id?: number | null;
  site?: Site | null;
  transaction_date: string | Date;
  valid_until_date?: string | Date | null;
  reference_number?: string | null;
  terms_and_conditions?: string | null;
  notes?: string | null;
  items: DocumentItemResponse[];
  status: DocumentStatusEnum;
  total_amount: number;
  created_at: string;
  updated_at: string;
} 